import api from "@src/utils/api";

export const fetchAutoComplete = (params) => {
  return api.get('/search/autocomplete', { params });
};

export const fetchSearchBytype = (params) => {
  return api.get('/search/bytype', { params });
};
